<template>
  <div class="userCenter">
    <div class="head">
      <img src="../../assets/images/logo.png" alt="" class="logo" />
      <div class="line"></div>
      <el-button @click="$router.back()" slot="btn" class="backBtn">
        <svg width="1em" height="1em" fill="currentColor" aria-hidden="true">
          <use xlink:href="#icon-fanhui1"></use>
        </svg>
        返回
      </el-button>
    </div>
    <div class="title">个人中心</div>
    <div class="box">
      <ul>
        <li>
          <div class="label avatar">
            <img
              :src="userInfomation.profilePhoto"
              alt="img"
              class="avatar"
              v-if="userInfomation.profilePhoto"
            />
            <img
              src="~@/assets/images/head_fill.png"
              alt="img"
              class="avatar"
              v-else
            />
            <div class="avatarShade" @click="open(6)">编 辑</div>
          </div>
        </li>
        <li>
          <div class="label">用户名</div>
          <div class="value">{{ nickname }}</div>
          <el-button @click="open(1)">编 辑</el-button>
        </li>
        <li>
          <div class="label">手机号</div>
          <div class="value">
            <img src="~@/assets/images/check.png" alt="img" class="avatar" />{{
              userId
            }}
          </div>
          <el-button @click="open(2)">编 辑</el-button>
        </li>
        <li>
          <div class="label">密码</div>
          <div class="value">
            <img
              src="~@/assets/images/check.png"
              alt="img"
              class="avatar"
              style="transform: translateY(-2px)"
            />***********
          </div>
          <el-button @click="open(4)">编 辑</el-button>
        </li>
        <li>
          <div class="label">微信账号</div>
          <div class="value">
            <img
              :src="
                bindWechat
                  ? require('@/assets/images/check.png')
                  : require('@/assets/images/noWechat.png')
              "
              alt="img"
              class="avatar"
            />{{
              bindWechat
                ? "你已绑定微信账号，可以通过微信扫码登录"
                : "未绑定微信账号，绑定后可以通过微信扫码登录"
            }}
          </div>
          <el-button @click="open(8)">{{
            bindWechat ? "更换绑定微信" : "绑 定"
          }}</el-button>
        </li>
      </ul>
    </div>
    <div class="shade" v-if="boxType > 0">
      <!--    修改用户名-->
      <div class="box" v-if="boxType === 1">
        <div class="box-title">修改用户名</div>
        <div class="center">
          <el-input
            v-model.trim="userInfo.nickName"
            placeholder="请输入用户名"
            clearable
            :onkeyup="
              (userInfo.nickName = userInfo.nickName.replace(/\s+/g, ''))
            "
            maxlength="20"
            show-word-limit
          ></el-input>
        </div>
        <div class="btns">
          <el-button @click="close">取消</el-button>
          <el-button
            type="primary"
            :disabled="!userInfo.nickName"
            @click="updateUserInfo"
            >确认</el-button
          >
        </div>
      </div>
      <!--    修改手机号-->
      <div class="box" v-if="boxType === 2">
        <div class="box-title">修改手机号</div>
        <div class="center">
          <el-input
            class="phone-input"
            placeholder="请输入手机号"
            clearable
            :disabled="true"
            v-model.trim="phone"
          >
            <span slot="prefix" class="prefix">+86</span>
          </el-input>
          <el-input
            :class="codeErrorMsg ? 'codeErrorMsg' : ''"
            class="code-input"
            v-model.trim="code"
            placeholder="请输入验证码"
            clearable
            @blur="checkCode(code)"
            :onkeyup="(code = code.replace(/\s+/g, ''))"
          ></el-input>
          <div class="errorMsg">{{ errorMsg }}</div>
          <div class="errorMsg2">{{ codeErrorMsg }}</div>
          <el-button
            class="code-btn"
            :disabled="!phone"
            @click="getSmsCaptcha(1)"
            v-if="time === 60"
            >获取验证码</el-button
          >
          <el-button class="code-btn" v-else style="width: 96px"
            >{{ time }} s</el-button
          >
        </div>
        <div class="btns">
          <el-button @click="close">取消</el-button>
          <el-button
            type="primary"
            :disabled="errorMsg !== '' || !code || codeErrorMsg !== ''"
            @click="validateCode"
            >下一步</el-button
          >
        </div>
      </div>
      <!--    修改手机号第二步-->
      <div class="box" v-if="boxType === 3">
        <div class="box-title">修改手机号</div>
        <div class="center">
          <el-input
            class="phone-input"
            placeholder="请输入手机号"
            clearable
            @blur="validatePhone"
            :onkeyup="(newPhone = newPhone.replace(/\s+/g, ''))"
            :class="errorMsg ? 'codeErrorMsg' : ''"
            v-model.trim="newPhone"
          >
            <span slot="prefix" class="prefix">+86</span>
          </el-input>
          <el-input
            :class="codeErrorMsg ? 'codeErrorMsg' : ''"
            class="code-input"
            v-model="code2"
            placeholder="请输入验证码"
            clearable
            @blur="checkCode(code2)"
            :onkeyup="(code2 = code2.replace(/\s+/g, ''))"
          ></el-input>
          <div class="errorMsg">{{ errorMsg }}</div>
          <div class="errorMsg2">{{ codeErrorMsg }}</div>
          <el-button
            class="code-btn"
            :disabled="!newPhone || errorMsg !== ''"
            @click="getSmsCaptcha2"
            v-if="time2 === 60"
            >获取验证码</el-button
          >
          <el-button class="code-btn" v-else style="width: 96px"
            >{{ time2 }} s</el-button
          >
        </div>
        <div class="btns">
          <el-button @click="close">取消</el-button>
          <el-button
            type="primary"
            :disabled="errorMsg !== '' || !code2 || codeErrorMsg !== ''"
            @click="updatePhone"
            >确认</el-button
          >
        </div>
      </div>
      <!--    修改密码-->
      <div class="box" v-if="boxType === 4">
        <div class="box-title">修改密码</div>
        <div class="center">
          <el-input
            class="phone-input"
            placeholder="请输入手机号"
            clearable
            :disabled="true"
            v-model.trim="phone"
          >
            <span slot="prefix" class="prefix">+86</span>
          </el-input>
          <el-input
            :class="codeErrorMsg ? 'codeErrorMsg' : ''"
            class="code-input"
            v-model="code"
            placeholder="请输入验证码"
            clearable
            @blur="checkCode(code)"
            :onkeyup="(code = code.replace(/\s+/g, ''))"
          ></el-input>
          <div class="errorMsg">{{ errorMsg }}</div>
          <div class="errorMsg2">{{ codeErrorMsg }}</div>
          <el-button
            class="code-btn"
            :disabled="!phone"
            @click="getSmsCaptcha(2)"
            v-if="time === 60"
            >获取验证码</el-button
          >
          <el-button class="code-btn" v-else style="width: 96px"
            >{{ time }} s</el-button
          >
        </div>
        <div class="btns">
          <el-button @click="close">取消</el-button>
          <el-button
            type="primary"
            :disabled="errorMsg !== '' || !code || codeErrorMsg !== ''"
            @click="validateCodeByPsd"
            >下一步</el-button
          >
        </div>
      </div>
      <!--    修改密码第二步-->
      <div class="box" v-if="boxType === 5">
        <div class="box-title">修改密码</div>
        <div class="center">
          <el-input
            :class="errorMsg ? 'codeErrorMsg' : ''"
            @blur="validatePassword"
            class="psd-input"
            :type="isShowPassword ? 'text' : 'password'"
            v-model.trim="password"
            placeholder="请输入新密码"
            :onkeyup="(password = password.replace(/\s+/g, ''))"
          >
            <svg
              style="transform: translateY(3px)"
              width="1em"
              height="1em"
              fill="currentColor"
              aria-hidden="true"
              slot="suffix"
              @click="isShowPassword = !isShowPassword"
            >
              <use
                :xlink:href="
                  isShowPassword ? '#icon-browse' : '#icon-eye-close'
                "
              ></use>
            </svg>
          </el-input>
          <el-input
            :class="errorMsg2 ? 'codeErrorMsg' : ''"
            @blur="validatePassword2"
            v-model.trim="newPassword"
            :type="isShowPassword2 ? 'text' : 'password'"
            placeholder="请再次输入新密码"
            :onkeyup="(newPassword = newPassword.replace(/\s+/g, ''))"
          >
            <svg
              style="transform: translateY(3px)"
              width="1em"
              height="1em"
              fill="currentColor"
              aria-hidden="true"
              slot="suffix"
              @click="isShowPassword2 = !isShowPassword2"
            >
              <use
                :xlink:href="
                  isShowPassword2 ? '#icon-browse' : '#icon-eye-close'
                "
              ></use>
            </svg>
          </el-input>
          <div class="errorMsg">{{ errorMsg }}</div>
          <div class="errorMsg2">{{ errorMsg2 }}</div>
        </div>
        <div class="btns">
          <el-button @click="close">取消</el-button>
          <el-button
            type="primary"
            :disabled="
              password === '' || newPassword === '' || errorMsg2 !== ''
            "
            @click="changePsd"
            >确认</el-button
          >
        </div>
      </div>
      <!--    编辑头像-->
      <div class="avatarBox box" v-if="boxType === 6">
        <div class="box-title">编辑头像</div>
        <div class="center">
          <div class="left">
            <el-upload
              class="upload-demo"
              drag
              action=""
              accept=".jpg,.png"
              :http-request="onUpload"
              :on-success="handleSuccess"
              :before-upload="beforeUpload"
              :show-file-list="false"
            >
              <svg
                width="4em"
                height="4em"
                fill="rgba(255, 255, 255, 0.5)"
                aria-hidden="true"
              >
                <use xlink:href="#icon-shangchuan-copy"></use>
              </svg>
              <div class="el-upload__text">点击上传头像</div>
            </el-upload>
            <div class="preview" v-if="showPreviewImg">
              <img :src="imageUrl" alt="" />
            </div>
          </div>
          <div class="right">
            <img :src="imageUrl" alt="" />
            <p>头像预览</p>
          </div>
        </div>
        <p class="tip">支持jpg、png格式的图片大小，大小不超过3M</p>
        <div class="btns">
          <el-upload
            v-if="showPreviewImg"
            class="upload-demo2"
            drag
            action=""
            accept=".jpg,.png"
            :http-request="onUpload"
            :on-success="handleSuccess"
            :before-upload="beforeUpload"
            :show-file-list="false"
          >
            <div class="el-upload__text">重新上传</div>
          </el-upload>
          <el-button @click="close">取消</el-button>
          <el-button type="primary" @click="submitAvatar">确认</el-button>
        </div>
      </div>
      <div class="box toLoginBox" v-if="boxType === 7">
        <img src="../../assets/images/ok.png" alt="img" />
        <p>修改成功</p>
        <div>{{ time3 }}s 后进入登录页面</div>
        <el-button type="primary" class="btn" @click="toLogin"
          >返回登录</el-button
        >
      </div>
      <!-- 微信绑定 -->
      <div class="qrCode" v-if="boxType === 8">
        <div class="header">
          <div class="titlewx">绑定微信</div>
          <i class="el-icon-circle-close" @click="close"></i>
        </div>
        <div v-if="!codeFailure" class="code-img" v-loading="loading">
          <img v-if="encodeLink" :src="encodeLink" alt="img" />
        </div>
        <div v-else class="qrcode1" @click="getQrcodeApi">
          <div>
            <img src="~@/assets/images/Refresh.svg" alt="" />
          </div>
        </div>
        <p v-if="!scanSuccess">扫码关注沸志科技公众号进行登录</p>
        <div v-else-if="isBind" class="alreadyBind">
          <p>{{ userId2 }}</p>
          <!-- <p>无法绑定当前账号</p> -->
        </div>
        <p v-else class="success">
          <img src="~@/assets/images/login-success.png" alt="" />
          <span>扫码成功</span>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { getSmsCaptcha, uploadOss } from '@/api/system'
import {
  updateUserInfo,
  updatePhone,
  validateCode,
  changePsd,
  validateCodeByPsd
} from '@/api/userCenter'
import { getBindQrcode, loginState, isExist } from '@/api/login'
import md5 from 'md5'
export default {
  name: 'index',
  props: {},
  components: {},
  data () {
    return {
      bindWechat: false, // 是否已绑定微信
      codeFailure: false, // 二维码是否失效
      loading: false,
      scanSuccess: false, // 扫码是否成功
      encodeLink: '',
      noncestr: '',
      isBind: false, // 该微信是否绑定光耀元账号
      userId2: '',

      boxType: 0,
      userName: '',
      phone: '',
      newPhone: '',
      code: '',
      code2: '',
      userInfo: {
        nickName: '',
        profilePhoto: ''
      },
      errorMsg: '',
      timer: null,
      timer2: null,
      timer3: null,
      timer4: null,
      time: 60,
      time2: 60,
      time3: 0,
      password: '',
      newPassword: '',
      errorMsg2: '',
      codeErrorMsg: '',
      imageUrl: '',
      showPreviewImg: false,
      isShowPassword: false,
      isShowPassword2: false
    }
  },
  computed: {
    ...mapGetters(['userId', 'nickname', 'userInfomation']),
    name () {
      return this.data
    }
  },
  mounted () {
    this.getIsBind()
  },
  destroyed () {
    this.timer4 && clearInterval(this.timer4)
  },
  methods: {
    ...mapActions(['GetInfo', 'Logout']),
    // 查询该用户是否已绑定微信
    async getIsBind () {
      const { data } = await isExist(this.userId)
      if (data.relevanceThirdPlatform[0]) {
        this.bindWechat = true
      } else {
        this.bindWechat = false
      }
    },
    // 获取二维码
    async getQrcodeApi () {
      this.codeFailure = false
      this.loading = true
      const { data } = await getBindQrcode(this.bindWechat)
      this.encodeLink = data.qrCode
      this.noncestr = data.noncestr
      this.loading = false
      this.timer4 = setInterval(() => {
        this.loginStateApi()
      }, 2000)
    },

    // 查询绑定状态
    async loginStateApi () {
      try {
        const { data } = await loginState(this.noncestr)
        // if (data.openId !== null) {
        //   this.scanSuccess = true
        // }
        if (data.status === 'BIND_SUCCESS') {
          this.scanSuccess = true
          this.getIsBind()
          this.close()
          if (this.bindWechat) {
            this.$message.success('换绑成功!')
          } else {
            this.$message.success('绑定成功!')
          }
        }
        if (data.status === 'ALREADY_BIND') {
          this.userId2 = data.desc
          this.scanSuccess = true
          this.isBind = true
        }
      } catch (error) {
        this.codeFailure = true
        this.timer4 && clearInterval(this.timer4)
      }
    },
    open (type) {
      this.boxType = type
      if (type === 1) {
        this.userInfo.nickName = this.nickname
      }
      if (type === 2 || type === 4) {
        this.phone = this.userId
      }
      if (type === 6) {
        this.imageUrl = this.userInfomation.profilePhoto
          ? this.userInfomation.profilePhoto
          : require('../../assets/images/head_fill.png')
        if (this.userInfomation.profilePhoto) {
          this.showPreviewImg = true
        }
      }
      if (type === 8) {
        this.getQrcodeApi()
      }
    },
    close () {
      this.timer4 && clearInterval(this.timer4)
      this.scanSuccess = false
      this.isBind = false
      this.code = ''
      this.code2 = ''
      this.errorMsg = ''
      this.boxType = 0
      this.imageUrl = ''
      this.showPreviewImg = false
      this.password = ''
      this.newPassword = ''
      this.errorMsg2 = ''
      this.codeErrorMsg = ''
    },
    // 更新用户信息
    updateUserInfo () {
      updateUserInfo(this.userInfo).then((res) => {
        if (res.code === 200) {
          this.close()
          this.$Message('success', '保存成功!')
          // 更新用户信息
          this.$store.dispatch('GetInfo')
        }
      })
    },
    // 手机号验证
    validatePhone () {
      const value = this.newPhone
      const reg = /^[1][0-9][0-9]{9}$/
      if (
        value === '' ||
        value === undefined ||
        value === null ||
        value === 'admin'
      ) {
        this.errorMsg = '请输入手机号码'
      } else {
        if (!reg.test(value) && value !== '') {
          this.errorMsg = '请输入正确的手机号码'
        } else {
          this.errorMsg = ''
        }
      }
    },
    // 密码验证
    validatePassword () {
      const value = this.password
      const reg = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,12}$/ // 校验密码6-12位
      if (value === '' || value === undefined || value == null) {
        this.errorMsg = '请输入密码'
      } else if (!reg.test(value)) {
        this.errorMsg = '密码须包含数字、字母两种元素，且密码位数为6-12位'
      } else {
        this.errorMsg = ''
      }
    },
    validatePassword2 () {
      const value = this.newPassword
      const reg = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,12}$/ // 校验密码6-12位
      if (value === '' || value === undefined || value == null) {
        this.errorMsg2 = '请输入密码'
      } else if (!reg.test(value)) {
        this.errorMsg2 = '密码须包含数字、字母两种元素，且密码位数为6-12位'
      } else if (value !== this.password) {
        this.errorMsg2 = '两次密码输入不一致，请重新输入！'
      } else {
        this.errorMsg2 = ''
      }
    },
    checkCode (value) {
      const reg = /^\d+(\.\d+)?$/
      if (value.length !== 6) {
        this.codeErrorMsg = '请输入6位数字验证码'
      } else if (!reg.test(value)) {
        this.codeErrorMsg = '请输入6位数字验证码'
      } else {
        this.codeErrorMsg = ''
      }
    },
    // 获取验证码
    getSmsCaptcha (type) {
      this.time = 59
      this.timer = setInterval(() => {
        this.time--
        if (this.time === 0) {
          clearInterval(this.timer)
          this.timer = null
          this.time = 60
        }
      }, 1000)
      getSmsCaptcha({
        type: type === 1 ? 'feige_old_phone_verify' : 'feige_reset_password',
        mobilePhone: this.phone
      })
        .then((res) => {
          if (res.code === 200) {
            this.$message.success('验证码已发送')
          }
        })
        .catch((err) => {
          console.log(err)
        })
    },
    // 获取验证码 (新手机号)
    getSmsCaptcha2 () {
      this.time2 = 59
      this.timer2 = setInterval(() => {
        this.time2--
        if (this.time2 === 0) {
          clearInterval(this.timer2)
          this.timer2 = null
          this.time2 = 60
        }
      }, 1000)
      getSmsCaptcha({
        type: 'feige_reset_phone',
        mobilePhone: this.newPhone
      })
        .then((res) => {
          if (res.code === 200) {
            this.$message.success('验证码已发送')
          }
        })
        .catch((err) => {
          console.log(err)
        })
    },
    // 验证验证码是否正确
    validateCode () {
      validateCode({ code: this.code, mobilePhone: this.phone }).then((res) => {
        if (res.code === 200) {
          this.open(3)
        }
      })
    },
    validateCodeByPsd () {
      validateCodeByPsd({
        code: this.code,
        mobilePhone: this.phone,
        type: 'feige_reset_password'
      }).then((res) => {
        if (res.code === 200) {
          this.open(5)
        }
      })
    },
    // 修改手机号
    updatePhone () {
      const mobilePhoneModel = {
        code: this.code2,
        mobilePhone: this.newPhone
      }
      updatePhone(mobilePhoneModel).then((res) => {
        if (res.code === 200) {
          this.close()
          this.open(7)
          this.time3 = 5
          this.timer3 = setInterval(() => {
            this.time3--
            if (this.time3 === 0) {
              clearInterval(this.timer3)
              this.timer3 = null
              this.toLogin()
            }
          }, 1000)
        }
      })
    },
    // 修改密码
    changePsd () {
      const params = {
        code: this.code,
        password: md5(this.password)
      }
      changePsd(params).then((res) => {
        if (res.code === 200) {
          this.close()
          this.open(7)
          this.time3 = 5
          this.timer3 = setInterval(() => {
            this.time3--
            if (this.time3 === 0) {
              clearInterval(this.timer3)
              this.timer3 = null
              this.toLogin()
            }
          }, 1000)
        }
      })
    },
    beforeUpload (file) {
      const isPic =
        file.type === 'image/jpg' ||
        file.type === 'image/png' ||
        file.type === 'image/jpeg'
      const isLt2M = file.size / 1024 < 3072
      if (!isPic) {
        this.$Message('warning', '上传图片只能是 JPG, PNG 格式!')
      } else if (!isLt2M) {
        this.$Message('warning', '上传图片大小不能超过 3M!')
      }
      return isPic && isLt2M
    },
    handleSuccess (res, file) {
      this.imageUrl = URL.createObjectURL(file.raw)
      this.showPreviewImg = true
    },
    async onUpload (file, fileList) {
      const res = await uploadOss(file.file)
      if (res && res.url) {
        this.userInfo.profilePhoto = res.url
      }
    },
    submitAvatar () {
      if (this.userInfo.profilePhoto) {
        this.updateUserInfo()
      }
    },
    toLogin () {
      if (this.timer3) {
        clearInterval(this.timer3)
        this.timer3 = null
      }
      // 重新登录
      this.Logout().then(() => {
        this.$router.push({ name: 'Login' })
      })
      localStorage.removeItem('account')
      localStorage.removeItem('password')
    }
  },
  filters: {}
}
</script>

<style lang="scss">
.userCenter {
  width: 100vw;
  height: 100vh;
  position: relative;
  box-sizing: border-box;
  background: #18191a;
  .head {
    width: 100%;
    height: 48px;
    background-color: #272829;
    border-bottom: 1px solid #000000;
    display: flex;
    align-items: center;
    padding-left: 20px;
    .logo {
      margin-right: 20px;
    }
    .line {
      width: 1px;
      height: 30px;
      background-color: #4a4b4c;
      margin-right: 20px;
    }
  }
  .title {
    font-size: 24px;
    font-family: Source Han Sans SC;
    font-weight: 500;
    color: #ffffff;
    padding-left: 460px;
    text-align: left;
    margin: 30px 0;
  }
  .box {
    width: 1000px;
    height: 550px;
    background: #272829;
    box-shadow: 0px 2px 20px 0px rgba(0, 0, 0, 0.5);
    border-radius: 12px;
    margin: 0 auto;
    box-sizing: border-box;
    padding: 28px 32px;
    > ul {
      list-style: none;
      padding: 0;
      margin: 0;
      > li {
        border-bottom: 1px solid rgba(255, 255, 255, 0.05);
        padding-bottom: 20px;
        text-align: left;
        margin-bottom: 20px;
        position: relative;
        &:last-child {
          border: 0;
        }
        button {
          position: absolute;
          right: 20px;
          top: 25px;
        }
        .label {
          font-size: 14px;
          font-family: Source Han Sans SC;
          font-weight: 500;
          color: #ffffff;
          margin-bottom: 17px;
          > img {
            margin-right: 10px;
            width: 80px;
            height: 80px;
            border-radius: 50%;
            display: inline-block;
          }
          .avatarShade {
            width: 80px;
            height: 80px;
            border-radius: 50%;
            position: absolute;
            background-color: rgba(0, 0, 0, 0.5);
            cursor: pointer;
            line-height: 80px;
            text-align: center;
            top: 0;
            transition: all 0.3s;
            opacity: 0;
            &:hover {
              opacity: 1;
            }
          }
        }
        .value {
          font-size: 12px;
          font-family: Source Han Sans SC;
          font-weight: 300;
          color: #999999;
        }
      }
    }
  }
  .shade {
    width: 100vw;
    height: 100vh;
    position: absolute;
    top: 0;
    left: 0;
    background-color: rgba(0, 0, 0, 0.4);
    display: flex;
    align-items: center;
    justify-content: center;
    .box {
      width: 460px;
      height: auto;
      background: #3d3e40;
      border: 1px solid #565759;
      box-shadow: 0px 2px 20px 0px rgba(0, 0, 0, 0.8);
      border-radius: 12px;
      transform: translateY(-50%);
      box-sizing: border-box;
      padding: 20px;
      padding-top: 10px;
      .box-title {
        text-align: left;
        font-size: 16px;
        font-family: Source Han Sans SC;
        font-weight: 400;
        color: #ffffff;
        padding: 0;
        margin-bottom: 20px;
      }
      .center {
        margin-bottom: 30px;
        .phone-input {
          margin-bottom: 20px;
          .el-input__inner {
            padding-left: 50px;
          }
          .el-input__prefix {
            .prefix {
              display: inline-block;
              height: 100%;
              line-height: 32px;
              position: relative;
              &:after {
                position: absolute;
                content: "";
                height: 18px;
                width: 1px;
                background-color: #ffffff;
                top: 7px;
                left: 35px;
              }
            }
          }
        }
        .psd-input {
          margin-bottom: 20px;
        }
        .code-input {
          width: 308px;
          transform: translateX(-7px);
        }
        .code-btn {
          transform: translateX(6px);
        }
      }
      .btns {
        text-align: right;
        > button {
          width: 80px;
        }
        .reset {
          float: left;
          cursor: pointer;
          &:hover {
            color: #00a4f0;
          }
        }
      }
    }
    .avatarBox {
      width: 460px;
      height: 463px;
      background: #3d3e40;
      border: 1px solid #565759;
      box-shadow: 0px 2px 20px 0px rgba(0, 0, 0, 0.8);
      border-radius: 12px;
      transform: translateY(0);
      .center {
        margin-bottom: 20px;
        display: flex;
        align-items: start;
        justify-content: space-between;
        .left {
          width: 290px;
          height: 290px;
          background: rgba(255, 255, 255, 0.1);
          border: 1px dashed #00a4f0;
          border-radius: 6px;
          display: flex;
          align-items: center;
          justify-content: center;
          position: relative;
          overflow: hidden;
          .upload-demo {
            transform: translateY(40px);
            .el-upload {
              width: 100% !important;
              .el-upload-dragger {
                width: 100% !important;
                background-color: unset;
                border: 0;
                .el-upload__text {
                  color: white !important;
                }
                .icon {
                  width: 40px;
                  height: 35px;
                }
              }
            }
          }
          .preview {
            width: 100%;
            height: 100%;
            position: absolute;
            top: 0;
            left: 0;
            z-index: 100;
            background-color: rgb(75, 75, 75);
            > img {
              width: 100%;
              height: 100%;
            }
          }
        }
        .right {
          width: 80px;
          height: 100px;
          transform: translateX(-10px);
          > img {
            width: 80px;
            height: 80px;
            display: block;
            border-radius: 50%;
          }
          > p {
            margin-top: 10px;
            font-size: 14px;
            font-family: Source Han Sans SC;
            font-weight: 300;
            color: #ffffff;
          }
        }
      }
      .tip {
        text-align: left;
        margin-bottom: 25px;
        font-size: 14px;
        font-family: Source Han Sans SC;
        font-weight: 400;
        color: #999999;
      }
      .upload-demo2 {
        width: 80px;
        height: 30px;
        position: absolute;
        transform: translate(-11px, 5px);
        .el-upload {
          width: 100% !important;
          height: 100% !important;
        }
        .el-upload-dragger {
          width: 100% !important;
          background-color: unset !important;
          height: 100% !important;
          border: 0;
          .el-upload__text {
            color: white;
            font-size: 14px;
          }
        }
      }
    }
    .toLoginBox {
      padding-top: 31px;
      padding-bottom: 31px;
      > img {
        margin-bottom: 20px;
      }
      .btn {
        margin-top: 29px;
      }
      > p {
        font-size: 18px;
        font-family: Source Han Sans SC;
        font-weight: 500;
        color: #ffffff;
        margin-bottom: 5px;
      }
    }
    .qrCode {
      width: 320px;
      height: 380px;
      border-radius: 24px;
      background: #272829;
      text-align: center;

      .header {
        position: relative;
        margin: 45px 0 31px 0;
        .titlewx {
          letter-spacing: 1px;
          font-size: 20px;
          font-family: Source Han Sans SC;
          color: #ffffff;
          text-align: center;
        }
        .el-icon-circle-close {
          font-size: 20px;
          color: #bbbbbb;
          position: absolute;
          right: 14px;
          top: -30px;
          cursor: pointer;
        }
      }
      .qrcode1 {
        margin: 31px auto;
        width: 162px;
        height: 162px;
        background: url("~@/assets/images/wechat-bg.jpg") no-repeat;
        background-size: cover;
        border-radius: 6px;
        overflow: hidden;
        cursor: pointer;
        div {
          width: 100%;
          height: 100%;
          line-height: 162px;
          border-radius: 6px;
          background: rgba(0, 0, 0, 0.7);
          img {
            width: 28px;
          }
        }
      }
      .code-img {
        margin: 31px auto;
        width: 162px;
        height: 162px;
        border-radius: 6px;
        overflow: hidden;
        > img {
          width: 162px;
          height: 162px;
          border-radius: 6px;
        }
      }
      .alreadyBind {
        color: #f2ab3f;
        p {
          margin: 0 37px;
        }
      }
      .success {
        display: flex;
        align-items: center;
        justify-content: center;
        img {
          width: 26px;
          margin-right: 8px;
        }
      }
    }
  }
  .errorMsg {
    position: absolute;
    top: 86px;
    color: #f54949;
    font-size: 12px;
  }
  .errorMsg2 {
    position: absolute;
    top: 140px;
    color: #f54949;
    font-size: 12px;
  }
  .codeErrorMsg {
    > input {
      border: 1px solid #f54949;
    }
  }
}
</style>
